export const PageContextConstant = {
  PAGE_CURRENT: 'PAGE_CURRENT',
  PAGE_CATALOG: 'PAGE_CATALOG',
  PAGE_PROMOTION: 'PAGE_PROMOTION',
  PAGE_CART: 'PAGE_CART',
};
